<template>
  <div :class="[
    $style.message,
    $style[message.align],
    `chat-window__message--${message.align}`
  ]">
    <div :class="$style.meta">
      <div :class="$style.photoContainer">
        <img :src="message.user.photoUrl" alt="" />
      </div>
      <span v-if="message.time" :class="$style.time">{{ message.time }}</span>
    </div>
    <div ref="message" :class="$style.msgContainer">{{ message.message }}</div>
  </div>
</template>

<script>
  import { linkifyElement } from 'vue-components/utils/linkify'

  export default {
    props: ['message'],
    mounted () {
      linkifyElement(this.$refs.message)
    }
  }
</script>

<style module lang="less" src="./message.less"></style>



// WEBPACK FOOTER //
// message.vue?a51a6030